// extracted by mini-css-extract-plugin
module.exports = {"underline":"index-module--underline--Qg8uO","document":"index-module--document--1s7CJ","fullscreen":"index-module--fullscreen--1m1pI","hero":"index-module--hero--2Osae"};